import { gql } from '@apollo/client';

export default gql`
  query inspectionResults(
    $inspectionId: ID!
    $page: Int
    $doneAtFrom: ISO8601DateTime
    $doneAtTo: ISO8601DateTime
    $doneById: ID
    $result: Int
    $sortBy: String
  ) {
    inspectionResults(
      inspectionId: $inspectionId
      page: $page
      doneAtFrom: $doneAtFrom
      doneAtTo: $doneAtTo
      doneById: $doneById
      result: $result
      sortBy: $sortBy
    ) {
      perPage
      hasNextPage
      currentPage
      inspectionResultsTotal
      inspectionResultsTotalPages
      inspectionResults {
        id
        doneAt
        result
        notes
        doneBy {
          id
          name
          surname
          email
        }
        inspectionResultFields {
          id
          inspectionFieldId
          name
          order
          value
        }
      }
    }
  }
`;
